import { DataService } from "@/services/data";
import { isFeatureEnabled } from "@/utils/feature-flag";
import { RouteObject } from "react-router-dom";
import { toast } from "sonner";

// Match rows carry an SFOpportunity id under the flag and a legacy offer id without it.
// The backend needs to know which one it receives to look the record up in the right space.
const matchSourceQuery = () => (isFeatureEnabled("apprenticeship-standard-matches") ? "?source=sf" : "");

const MatchRoute: RouteObject = {
    path: "matchs",
    children: [
        {
            index: true,
            async lazy() {
                let { ListOffers } = await import("@/pages/apprenticeship/match/list-offers");
                return { Component: ListOffers };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);

                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                if (isFeatureEnabled("apprenticeship-standard-matches")) {
                    url.searchParams.set("source", "sf");
                }

                const offers = await DataService.client
                    .url(`/apprenticeship/offers/match/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return { offers };
            }
        },
        {
            path: "candidats",
            async lazy() {
                let { ListOffers } = await import("@/pages/apprenticeship/match/candidate-list-offers");
                return { Component: ListOffers };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);

                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                if (isFeatureEnabled("apprenticeship-standard-matches")) {
                    url.searchParams.set("source", "sf");
                }

                const registrations = await DataService.client
                    .url(`/apprenticeship/registrations/match/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return { registrations };
            }
        },
        {
            path: "mark_ineligible",
            action: async ({ request }) => {
                const data = await request.json();
                const resp = await DataService.client.url(`/apprenticeship/offers/${data.offer.id}/mark_ineligible/${matchSourceQuery()}`).post(data).json();
                toast.success("Offre cachée avec succès");
                return { success: true, content: resp };
            }
        },
        {
            path: "transfer",
            action: async ({ request }) => {
                try {
                    const data = await request.json();
                    const resp = await DataService.client.url(`/apprenticeship/offers/${data.offer.id}/transfer/${matchSourceQuery()}`).post(data).json();
                    toast.success("Offre transférée avec succès");
                    return { success: true, content: resp };
                } catch (error) {
                    toast.error("Une erreur est survenue");
                    return { error };
                }
            }
        }
    ]
};

export default MatchRoute;
